/** @type {Map<HTMLElement, EventListener>} */
let elementListenersMap = null;


/**
 * Note this is expecting a CSS transition to be in
 * place for `$el`'s `height` property.
 *
 * @param {HTMLElement} $el
 * @param {boolean} isExpanding
 */
function expandCollapse($el, isExpanding) {
  const { style } = $el;
  const currentHeight = $el.clientHeight;
  let targetHeight;

  if (elementListenersMap === null) {
    elementListenersMap = new Map();
  } else {
    if (elementListenersMap.has($el)) {
      const handler = elementListenersMap.get($el);
      $el.removeEventListener('transitionend', handler);
    }
  }

  const onTransitionEnd = (event) => {
    if (event.propertyName === 'height') {
      $el.removeEventListener('transitionend', onTransitionEnd);
      elementListenersMap.delete($el);

      style.removeProperty('height');

      if (!isExpanding) {
        style.setProperty('display', 'none');
      }
    }
  };

  $el.addEventListener('transitionend', onTransitionEnd);
  elementListenersMap.set($el, onTransitionEnd);

  if (isExpanding) {
    style.removeProperty('display');
    style.setProperty('height', 'auto');

    targetHeight = $el.clientHeight;
  } else {
    targetHeight = 0;
  }

  style.setProperty('height', `${currentHeight}px`);

  window.requestAnimationFrame(() => {
    style.setProperty('height', `${targetHeight}px`);
  });
}


/**
 * @param {HTMLElement} $el
 */
function expand($el) {
  expandCollapse($el, true);
}


/**
 * @param {HTMLElement} $el
 */
function collapse($el) {
  expandCollapse($el, false);
}


export default {
  expand,
  collapse,
};



// WEBPACK FOOTER //
// ./src/utils/dom-effects.js